import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaCheck, FaArrowLeft } from 'react-icons/fa';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Navbar from '../components/Navbar';
import './ServicePage.css';

const AIAutomation = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: true,
      offset: 100
    });
    window.scrollTo(0, 0);
  }, []);

  const services = [
    {
      category: 'OpenAI Integrations',
      items: [
        'GPT API integration',
        'ChatGPT-powered features',
        'Text generation & analysis',
        'Content creation automation',
        'Natural language processing'
      ]
    },
    {
      category: 'Chatbots',
      items: [
        'AI-powered chatbots',
        'Customer support automation',
        'Multi-language support',
        'Conversational AI',
        'Integration with messaging platforms'
      ]
    },
    {
      category: 'Training ML Models',
      items: [
        'Custom ML model development',
        'Data preprocessing & training',
        'Model optimization',
        'Model deployment',
        'Continuous learning systems'
      ]
    },
    {
      category: 'Predictive Analytics',
      items: [
        'Data analysis & insights',
        'Forecasting models',
        'Trend prediction',
        'Risk assessment',
        'Business intelligence dashboards'
      ]
    },
    {
      category: 'Workflow Automation',
      items: [
        'Process automation',
        'Task scheduling & triggers',
        'Integration automation',
        'Data pipeline automation',
        'Business process optimization'
      ]
    }
  ];

  return (
    <div className="service-page">
      <Navbar />
      <div className="service-hero">
        <Link to="/" className="back-button" data-aos="fade-right">
          <FaArrowLeft /> Back to Home
        </Link>
        <div className="service-hero-content" data-aos="fade-up">
          <h1 className="service-page-title">AI & Automation</h1>
          <p className="service-hero-tagline">Leverage artificial intelligence and automation to transform your business operations.</p>
        </div>
      </div>

      <div className="service-content">
        <div className="service-section" data-aos="fade-up">
          <h2 className="section-heading">Overview</h2>
          <p className="section-text">
            We integrate cutting-edge AI technologies and automation solutions to enhance your business processes, 
            improve customer experiences, and drive operational efficiency. From OpenAI integrations to custom ML models, 
            we help you harness the power of artificial intelligence.
          </p>
        </div>

        <div className="service-section" data-aos="fade-up">
          <h2 className="section-heading">Our AI & Automation Services</h2>
          {services.map((service, index) => (
            <div key={index} className="ai-service-category" data-aos="fade-up" data-aos-delay={index * 100}>
              <h3 className="category-title">{service.category}</h3>
              <div className="features-grid">
                {service.items.map((item, itemIndex) => (
                  <div key={itemIndex} className="feature-item" data-aos="fade-up" data-aos-delay={index * 100 + itemIndex * 50}>
                    <FaCheck className="check-icon" />
                    <span>{item}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="service-cta" data-aos="fade-up">
          <Link to="/contact" className="cta-button-primary">
            Get Started →
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AIAutomation;

